/**
 * @file The scope labels document at `parameters/analyticsLabels`: the name the UI shows for each
 * analytics scope level (My sales, My team, Org overall by default), plus the optional naming fields
 * the tabs and Home read: the team noun and its plural, the My sales name on Home and on Projects,
 * and the Org sub-label under the Org tile on Home. Read by React, written only by an enabled
 * `metricsAdmin` under `firestore.rules`, with an emulator example in `data/examples`. The
 * analytics service reads only `teamNoun`, to freeze it into report runs, so a label change never
 * reaches SQL. A reader treats a missing or blank label as unset and shows its own default for that
 * field alone.
 */
import type { AnalyticsScopeLevel } from './Analytics.NamedQuery.types';

export const ANALYTICS_SCOPE_LABELS_PATH = 'parameters/analyticsLabels';

/** The team noun shown when `teamNoun` is unset: the React scope labels' default, and the fill for a stored report run that froze no noun. */
export const ANALYTICS_DEFAULT_TEAM_NOUN = 'Team';

export type AnalyticsScopeLabels = Record<AnalyticsScopeLevel, string> & {
  teamNoun?: string;
  teamNounPlural?: string;
  selfHome?: string;
  selfProjects?: string;
  orgSubLabel?: string;
};
